export enum SoftwareType {
  Application = 'application',
  Os = 'os',
  Other = 'other',
  SystemPackage = 'systemPackage',
}

export interface Applications {
  readonly installDate?: string;
  readonly packageId: string;
  readonly packageName: string;
  readonly sizeOnDisc?: number;
  readonly type: string;
  readonly versionCode: string;
  readonly version: string;
}
export interface ApplicationsList {
  readonly applications: Applications[];
}
